export interface Reward {
  name: string;
  /**
   * The slug of a dotation is used to identify the dotation in the backend with `/api/dotations`.
   * It must be exactly the same as the slug in the backend.
   */
  slug: string;
  i18nName: string;
  images: {
    carousel: string;
    card: string;
  };
  points: number;
}

export const rewards: Record<"galbani" | "lactel", Reward[]> = {
  galbani: [
    {
      name: "dialog.rewards.knife.title",
      slug: "dotation1",
      i18nName: "knife",
      images: {
        carousel: "/images/products-carousel/knife.png",
        card: "/images/products-card/knife.png",
      },
      points: 1,
    },
    {
      name: "dialog.rewards.ovenMitt.title",
      slug: "dotation2",
      i18nName: "ovenMitt",
      images: {
        carousel: "/images/products-carousel/oven-mitt.png",
        card: "/images/products-card/oven-mitt.png",
      },
      points: 25,
    },
    {
      name: "dialog.rewards.cutlerySet.title",
      slug: "dotation3",
      i18nName: "cutlerySet",
      images: {
        carousel: "/images/products-carousel/cutlery-set.png",
        card: "/images/products-card/cutlery-set.png",
      },
      points: 70,
    },
    {
      name: "dialog.rewards.lunchBox.title",
      slug: "dotation4",
      i18nName: "lunchBox",
      images: {
        carousel: "/images/products-carousel/lunch-box.png",
        card: "/images/products-card/lunch-box.png",
      },
      points: 95,
    },
    {
      name: "dialog.rewards.cookingPot.title",
      slug: "dotation5",
      i18nName: "cookingPot",
      images: {
        carousel: "/images/products-carousel/cooking-pot.png",
        card: "/images/products-card/cooking-pot.png",
      },
      points: 120,
    },
    {
      name: "dialog.rewards.kitchenBox.title",
      slug: "dotation6",
      i18nName: "kitchenBox",
      images: {
        carousel: "/images/products-carousel/kitchen-box.png",
        card: "/images/products-card/kitchen-box.png",
      },
      points: 140,
    },
  ],
  lactel: [
    {
      name: "dialog.rewards.magnets.title",
      slug: "dotation1-period2",
      i18nName: "magnets",
      images: {
        carousel: "/lactel/images/products/carousel/magnets.png",
        card: "/lactel/images/products/card/magnets.png",
      },
      points: 25,
    },
    {
      name: "dialog.rewards.socks.title",
      slug: "dotation2-period2",
      i18nName: "socks",
      images: {
        carousel: "/lactel/images/products/carousel/socks.png",
        card: "/lactel/images/products/card/socks.png",
      },
      points: 80,
    },
    {
      name: "dialog.rewards.bag.title",
      slug: "dotation3-period2",
      i18nName: "bag",
      images: {
        carousel: "/lactel/images/products/carousel/bag.png",
        card: "/lactel/images/products/card/bag.png",
      },
      points: 160,
    },
    {
      name: "dialog.rewards.ecard50.title",
      slug: "dotation4-period2",
      i18nName: "ecard50",
      images: {
        carousel: "/lactel/images/products/carousel/card-50.png",
        card: "/lactel/images/products/card/cards.png",
      },
      points: 250,
    },
    {
      name: "dialog.rewards.ecard100.title",
      slug: "dotation5-period2",
      i18nName: "ecard100",
      images: {
        carousel: "/lactel/images/products/carousel/card-100.png",
        card: "/lactel/images/products/card/cards.png",
      },
      points: 300,
    },
  ],
};
